"use client";

import type React from "react";

/**
 * What a checked box shows, shared by every control that draws a checkbox.
 *
 * `Checkbox` owns the box; a menu item whose ROW is the control
 * (`MenuCheckboxItem variant="checkbox"`) draws the same box on an indicator
 * it does not own. The face lives here, outside the public barrel, so the two
 * cannot drift and the glyph is not an export anyone can mount on its own.
 */

/** The filled face: the fill sits a hair outside the border so it covers it,
 *  and the tick centres in it. */
export const CHECKBOX_FILL_CLASS =
  "absolute -inset-px flex items-center justify-center rounded-[.25rem] text-primary-foreground";

/** The tick a checked box carries. */
export function CheckboxCheckGlyph(): React.ReactElement {
  return (
    <svg
      aria-hidden="true"
      className="size-3.5 sm:size-3"
      fill="none"
      height="24"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.252 12.7 10.2 18.63 18.748 5.37" />
    </svg>
  );
}
